import { IconButton, Stack, Tooltip } from "@mui/material";
import { Add, Edit, Eye, Trash } from "iconsax-react";
import { Row } from "react-table";
import {  useTheme } from '@mui/material/styles';
import { MouseEvent } from 'react';
interface Props {
    row: Row<{}>;
    alignItems?:any;
    justifyContent?:any;
   actionCallBack:{ handleView: (e: MouseEvent<HTMLButtonElement>,row:Row) => void;
    handleEdit: (e: MouseEvent<HTMLButtonElement>,row:Row) => void;
    handleDelete: (e: MouseEvent<HTMLButtonElement>,row:Row) => void;};
    actionDisable?:{view:boolean,edit:boolean,delete:boolean,}
  };
   
const  RowActions=({ row,actionCallBack ,actionDisable={view:false,edit:false,delete:false},alignItems='centre',justifyContent='centre'}: Props) => {
      const theme = useTheme();

      const collapseIcon = row.isExpanded ? <Add style={{ color: theme.palette.error.main, transform: 'rotate(45deg)' }} /> : <Eye />;
      return (
        <Stack direction="row" alignItems={alignItems} justifyContent={justifyContent} spacing={0}>
         {actionDisable.view? <></> : <Tooltip title="View">
            <IconButton
              color="secondary"
              onClick={(e: MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                row.toggleRowExpanded();
                actionCallBack.handleView(e,row);
              }}
            >
              {collapseIcon}
            </IconButton>
          </Tooltip>}
          {actionDisable.edit? <></> : <Tooltip title="Edit">
            <IconButton
              color="primary"
              onClick={(e: MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                actionCallBack.handleEdit(e,row);
              }}
            >
              <Edit />
            </IconButton>
          </Tooltip>}
          {actionDisable.delete? <></> : <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={(e: MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                actionCallBack.handleDelete(e,row);
              }}
            >
              <Trash />
            </IconButton>
          </Tooltip>}
        </Stack>
      );

  }
  
export default RowActions;
